// API Configuration - reads from environment variables
// In React, environment variables must start with REACT_APP_

const API_PREFIX = process.env.REACT_APP_API_PREFIX;

// OpenAI Configuration
const OPENAI_API_KEY = process.env.REACT_APP_OPENAI_API_KEY;
const OPENAI_MODEL = process.env.REACT_APP_OPENAI_MODEL;

export const API_URL = API_PREFIX;

export const API_ENDPOINTS = {
  sessionsCreate: `${API_URL}/api/v1/sessions/create`,
  avatarGenerate: () => {
    const visitorId = localStorage.getItem('visitor_id');
    const sessionId = localStorage.getItem('session-id');
    return { url: `${API_URL}/api/v1/ai-avatar/${visitorId}/generate`, sessionId };
  },
  avatarFetch: (visitorId, avatarId) => {
    const sessionId = localStorage.getItem('session-id');
    return { url: `${API_URL}/api/v1/ai-avatar/${visitorId}/${avatarId}`, sessionId };
  },
  sendWhatsAppMessage: (visitorId) => `${API_URL}/api/v1/visitors/whatsapp/${visitorId}/send-message`,
  generateTagline: `${API_URL}/api/v1/tagline/generate`,
};

// AIVA Voice Agent Configuration
export const AIVA_CONFIG = {
  // Welcome message that AIVA speaks when starting
  welcomeMessage: "Hello! Welcome to the India AI Impact Summit 2026. I'm AIVA, your AI assistant. To personalize your experience, could you please tell me your name and your company name?",
  
  // Follow-up questions based on collected info
  followUpQuestions: {
    noName: "Could you please tell me your name?",
    noCompany: "And which company or organization are you from?",
    noRole: (company) => `What is your role at ${company}?`,
    complete: "Thank you! Now, how can I assist you at the summit today?",
  },
};

export const OPENAI_CONFIG = {
  apiKey: OPENAI_API_KEY,
  model: OPENAI_MODEL,
  voice: 'shimmer', // Options: alloy, echo, fable, onyx, nova, shimmer
  instructions: `You are AIVA (AI Virtual Assistant), a friendly and helpful AI assistant for the India AI Impact Summit 2026. 

Your personality:
- Warm, welcoming, and professional
- Knowledgeable about AI topics and the summit
- Concise in responses (aim for 2-3 sentences)
- Always address the user by name when known

Your workflow:
1. Greet the user warmly and introduce yourself
2. Ask for their name and company name
3. After getting the company name, ask for their role at that company
4. Use their name in future responses
5. Ask how you can help them at the summit

Keep responses conversational and natural, as if speaking to a real person.`,
};

export default {
  API_URL,
  API_ENDPOINTS,
  OPENAI_CONFIG,
  AIVA_CONFIG,
};
